import { render, staticRenderFns } from "./RecentActivities.vue?vue&type=template&id=74ed6e48&scoped=true&"
import script from "./RecentActivities.vue?vue&type=script&lang=js&"
export * from "./RecentActivities.vue?vue&type=script&lang=js&"
import style0 from "./RecentActivities.vue?vue&type=style&index=0&id=74ed6e48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ed6e48",
  null
  
)

export default component.exports